/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import store from '../store'
import {getToken} from "../api/auth";
import { getAuthToken } from '@/utils/session'

export const allowOnlyAuthorized = () => {
  return (to, from, next) => {
    const isAuthenticated = getAuthToken()
    if (isAuthenticated) {
      next()
    } else {
      if (process.env.VUE_APP_IS_AAD_LOGIN === 'true') {
        getToken()
          .then(res => {
            if (res.data.token) {
              store.dispatch('updateAuthToken', res.data)
            } else {
              window.location = res.data.redirect
            }
          })
          .catch(() => {
          })
      } else {
        next({name: 'login'})
      }
    }
  }
}
